<template>
  <div ref="btn" @click="onClick" class="button" :class="classes">
    <div class="button__content">
      <div
        v-if="icon && !iconRight"
        class="button__icon button__icon--left"
        :class="{ 'button__icon--no-margin': !$slots.default }"
      >
        <fai :icon="icon" :size="iconSize"></fai>
      </div>
      <div class="button__text">
        <slot></slot>
      </div>
      <div
        v-if="icon && iconRight"
        class="button__icon button__icon--right"
        :class="{ 'button__icon--no-margin': !$slots.default }"
      >
        <fai :icon="icon" :size="iconSize"></fai>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      clicked: false,
    };
  },
  props: {
    icon: String,
    iconRight: Boolean,
    width: String,
    small: Boolean,
    inactive: Boolean,
    color: {
      type: String,
      default: "orange",
    },
    iconSize: {
      type: String,
      default: "1x",
    },
  },
  methods: {
    async onClick() {
      this.$emit("click");
      this.clicked = true;
      await this.delayMs(100);
      this.clicked = false;
    },
  },
  mounted() {
    if (this.width) {
      this.$refs.btn.style.width = this.width;
    }
  },
  computed: {
    classes() {
      let c = `button--${this.color}`;
      if (!this.$slots.default) c += " button--round";
      if (this.clicked) c += " button--clicked";
      if (this.small) c += " button--small";
      if (this.inactive) c += " button--inactive";
      return c;
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  @include boxShadow(0px, 9px, 10px, -12px, rgba(0, 0, 0, 0.75));
  display: inline-block;
  color: white;
  font-weight: 600;
  font-family: "Work Sans";
  text-transform: uppercase;
  padding: 8px 12px;
  border-radius: 1.3em;
  font-size: 1em;
  cursor: pointer;
  will-change: transform;
  transition: transform 0.1s ease;

  &__content {
    @include alignedFlex(center);
    user-select: none;
  }

  &--orange {
    background-color: $primary;
    &:hover {
      background-color: $primaryHover;
    }
  }

  &--red {
    background-color: $danger;
    &:hover {
      background-color: $dangerHover;
    }
  }

  &--green {
    background-color: $success;
    &:hover {
      background-color: $successHover;
    }
  }

  &--inactive {
    background-color: $inactiveGrey !important;
    cursor: default;
    pointer-events: none;
  }

  &--round {
    padding: 5px;
    border-radius: 50%;
  }

  &--clicked {
    transform: scale(1.02);
  }

  &--small {
    padding: 5px 7px;
    font-size: 0.9em;
    .button__icon {
      &--left {
        margin-right: 3px;
      }

      &--right {
        margin-left: 3px;
      }
    }
  }

  &__icon {
    width: 18px;
    height: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    &--left {
      margin-right: 6px;
    }
    &--right {
      margin-left: 6px;
    }
    &--no-margin {
      margin: 0;
    }
  }
}
</style>
